import AbstractDevice from '../all/AbstractDevice';
import NetrangeId from './Id';
import NetrangePlayer from './Player';
import NetrangePlayerUtil from './PlayerUtil';
import NetrangeConfig from './config';
import NetrangeKeys from './Keys';
import NetrangeNetworkStatus from './NetworkStatus';
import NetrangeSystem from './System';

class NetrangeDevice extends AbstractDevice {
  constructor() {
    super(
      'netrange' || 'netrangemmh',
      new NetrangeId(),
      new NetrangePlayer(),
      new NetrangePlayerUtil(),
      NetrangeConfig,
      new NetrangeKeys(),
      new NetrangeNetworkStatus(),
      new NetrangeSystem()
    );
  }
}

export default NetrangeDevice;



// WEBPACK FOOTER //
// ./src/devices/netrange/Device.js